import styled, { CSSObject } from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'
import * as RadixNav from '@radix-ui/react-navigation-menu'

export const HoverDropdownList = styled.ul({
  display: 'flex',
  flexDirection: 'column',
  padding: `${tokens.spacing[6]}`,
  minWidth: '13.875rem',
  background: tokens.color.yeezy.p,
  zIndex: tokens.zIndex.dropdown,
  width: 'max-content',
  border: `${tokens.borderWidth.xs} solid ${tokens.color.superstar[600]}`,

  'a + a': {
    marginTop: tokens.spacing[7]
  }
})

export const MyLacedContent = styled(RadixNav.Content)({
  position: 'absolute',
  width: '100%',
  top: '100%'
})

export const MegaMenuContent = styled(RadixNav.Content)({
  position: 'absolute',
  width: '100vw',
  top: '100%',
  left: 0
})

export const DesktopNavList = styled.span({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginRight: tokens.spacing[12],

  [mediaQuery.l.max]: {
    display: 'none'
  }
})

const BottomBorderHover: CSSObject = {
  '&::after': {
    borderBottom: `${tokens.borderWidth.s} solid ${tokens.color.airJordan.p}`,
    content: '""',
    display: 'block',
    width: '100%',
    position: 'absolute',
    bottom: '-0.188rem'
  }
}

export const NavItemTrigger = styled(RadixNav.Trigger)({
  '&[data-state="open"]': BottomBorderHover
})

export const BrowseNavItemTrigger = styled(RadixNav.Trigger)<{
  showBackdrop?: boolean
}>(({ showBackdrop }) => showBackdrop && BottomBorderHover)

const BaseLink: CSSObject = {
  position: 'relative',
  padding: `${tokens.spacing[6]}`
}

export const NavLinkComplex = styled(RadixNav.Link)(BaseLink)

export const NavLinkSimple = styled(RadixNav.Link)(BaseLink, {
  '&:hover': BottomBorderHover
})
